export default {
  mutateProfileLoadingState(state, loading) {
    state.profileLoadingState = loading;
  },
  mutateProfileErrorState(state, error) {
    state.profileErrorState = error;
  },
  mutateProfileDetailsState(state, details) {
    state.profileDetailsState = details;
  },
  mutateProfileDetailsFieldState(state, {field, value}) {
    let profile = state.profileDetailsState;
    profile[field] = value;
    state.profileDetailsState = profile;
  },
  mutateProfileCompletenessState(
    state,
    {profile_completeness, profile_completeness_progress, reached_all_required_fields}
  ) {
    state.profileDetailsState = {
      ...state.profileDetailsState,
      profile_completeness,
      profile_completeness_progress,
      reached_all_required_fields
    };
  },
  mutateProfileUpdateLoadingState(state, loading) {
    state.profileUpdateLoadingState = loading;
  },
  setReferralCreationReferredJob(state, job) {
    state.referralCreationReferredJob = job;
  },
  setShowRecommendedJobsNotFoundState(state, show) {
    state.showRecommendedJobsNotFound = show;
  }
};
